import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-b2b-operational-nav',
  templateUrl: './b2b-operational-nav.component.html',
  styleUrls: ['./b2b-operational-nav.component.css']
})
export class B2bOperationalNavComponent {
  @Input() contractId!: number;
  @Input() active:
    | 'operacional'
    | 'sinistros'
    | 'cobrancas'
    | 'reservas'
    | 'acessorios'
    | 'pagamentos'
    | 'faturas'
    | 'manutencoes'
    | 'multas'
    | 'substituicoes'
    | 'retornos'
    | 'entregas' = 'operacional';

  readonly links: Array<{
    key:
      | 'operacional'
      | 'sinistros'
      | 'cobrancas'
      | 'reservas'
      | 'acessorios'
      | 'pagamentos'
      | 'faturas'
      | 'manutencoes'
      | 'multas'
      | 'substituicoes'
      | 'retornos'
      | 'entregas';
    label: string;
    path: string;
    icon: string;
  }> = [
    { key: 'operacional', label: 'Dashboard', path: 'operacional', icon: 'fas fa-chart-pie' },
    { key: 'manutencoes', label: 'Manutenções', path: 'manutencoes', icon: 'fas fa-wrench' },
    { key: 'sinistros', label: 'Sinistros', path: 'sinistros', icon: 'fas fa-car-crash' },
    { key: 'multas', label: 'Multas', path: 'multas', icon: 'fas fa-gavel' },
    { key: 'cobrancas', label: 'Cobranças', path: 'cobrancas', icon: 'fas fa-file-invoice-dollar' },
    { key: 'faturas', label: 'Faturas', path: 'faturas', icon: 'fas fa-file-invoice' },
    { key: 'reservas', label: 'Reservas', path: 'reservas', icon: 'fas fa-calendar-check' },
    { key: 'substituicoes', label: 'Substituições', path: 'substituicoes', icon: 'fas fa-exchange-alt' },
    { key: 'retornos', label: 'Retornos', path: 'retornos', icon: 'fas fa-undo' },
    { key: 'entregas', label: 'Entregas', path: 'entregas', icon: 'fas fa-truck' },
    { key: 'acessorios', label: 'Acessórios', path: 'acessorios', icon: 'fas fa-toolbox' },
    { key: 'pagamentos', label: 'Pagamentos', path: 'pagamentos', icon: 'fas fa-money-check-alt' }
  ];
}
